import { Select, ConfigProvider } from "antd";
import "./styles.css";

const BasicSearchMultipleSelectCountry = (props) => {
  return (
    <div className="edit-profile-input">
      <ConfigProvider
        theme={{
          components: {
            Select: {
              activeBorderColor: "transparent",
              activeOutlineColor: "transparent",
              hoverBorderColor: "transparent",
              colorBorder: "transparent",
              colorBorderDisabled: "transaprent",
              colorBgBase: "transaprent",
            },
          },
        }}
      >
        <Select
          {...props}
          suffixIcon={null}
          mode="multiple"
          placeholder="Please select"
          className="edit-profile-select-multiple"
        >
          {props?.data?.map((item, index) => {
            if (!item?.name?.includes("Division")) {
              return (
                <Select.Option
                  key={index}
                  value={item.name.replace(" District", "")}
                >
                  {item.name.replace(" District", "")}
                </Select.Option>
              );
            }
          })}
        </Select>
      </ConfigProvider>
    </div>
  );
};

export default BasicSearchMultipleSelectCountry;
